import React, { useState } from 'react';
import moment from 'moment';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import useGlobal from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDatePicker from '../../../../facturotopia/calendar-date-picker/CalendarDatePicker';

const mapState = (store) => {
  return {
    reportes: store.admin.reportes.facturacion.hits_clientes,
  };
};

const mapActions = (actions) => {
  return { ...actions.admin.reportes.facturacion.hits_clientes };
};

const ReporteFacturacionClienteSearch = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const [date, setDate] = useState(new Date());

  const { filters } = state.reportes;

  const [index, setIndex] = useState();

  const handleOnKeywordChange = (keyword) => {
    actions.paginate({
      ...filters,
      search: keyword,
      field: index,
      date: date,
    });
  };

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  };

  const handleOnDateChange = (value) => {
    const fecha = moment(value.fecha).format('YYYY-MM-DD');

    setDate(value.fecha);

    actions.paginate({
      ...filters,
      date: fecha,
    });

    if (!!props.onDateChange) {
      props.onDateChange(fecha);
    }
  };

  const handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    setIndex(id);
  };

  const getOmnisearchLegend = () => {
    let legend = 'Cliente';

    switch (index) {
      case 'razon_social':
        legend = 'Razón Social';
        break;
      case 'nombre_comercial':
        legend = 'Nombre Comercial';
        break;
      case 'rfc':
        legend = 'RFC';
        break;
      case 'email':
        legend = 'Email';
        break;
      default:
        break;
    }

    return legend;
  };

  const { search } = filters;

  return (
    <div className="d-flex flex-column flex-sm-row">
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDatePicker
            name="fecha"
            format="yyyy"
            value={date}
            minDetail="decade"
            maxDetail="decade"
            onChange={handleOnDateChange}
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={handleOnKeywordChange}
            onClear={handleOnSearchClear}
            value={search}
          >
            <DropdownButton
              variant="outline-secondary"
              title={getOmnisearchLegend()}
              id="search-index"
              onSelect={handleOnSelectIndex}
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item id="razon_social">Razón Social</Dropdown.Item>
              <Dropdown.Item id="nombre_comercial">Nombre Comercial</Dropdown.Item>
              <Dropdown.Item id="rfc">RFC</Dropdown.Item>
              <Dropdown.Item id="email">Email</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    </div>
  );
};

export default ReporteFacturacionClienteSearch;
